import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function PartnersStrip({ title = "Our Partners & Sponsors", subtitle, compact = false }) {
  const [partners, setPartners] = useState([]);
  useEffect(() => { api.get("/partners").then((r) => setPartners(r.data || [])).catch(() => {}); }, []);

  if (partners.length === 0) return null;

  return (
    <section className={compact ? "py-12 bg-white" : "section-pad bg-white"} data-testid="partners-strip">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        {title && (
          <div className="text-center mb-10">
            <div className="eyebrow mb-3">Partners</div>
            <h2 className="font-display text-3xl sm:text-4xl text-[var(--bcol-navy)]">{title}</h2>
            {subtitle && <p className="text-[var(--bcol-muted)] mt-3 max-w-2xl mx-auto">{subtitle}</p>}
          </div>
        )}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 items-center">
          {partners.map((p) => {
            const Card = (
              <div className="card-soft p-6 flex items-center justify-center h-32 group" data-testid={`partner-${p.id}`}>
                <img src={p.logo_url} alt={p.name} title={p.name}
                  className="max-h-full max-w-full object-contain transition group-hover:scale-105" />
              </div>
            );
            return p.website_url ? (
              <a key={p.id} href={p.website_url} target="_blank" rel="noopener noreferrer" className="block">{Card}</a>
            ) : (
              <div key={p.id}>{Card}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
